import React from 'react' // Removed useState
import { ReactComponent as SelectOff} from '../../../images/svg/selected-no.svg'
import { ReactComponent as SelectOn} from '../../../images/svg/selected-yes.svg'
import { CBCheckItem } from './cbd'

const CBColorPicker = ({
  type,
  color = 'default', // This prop ('default', '11', 'Red category', etc.) is the source of truth
  onColorChangeCallback,
  preview = false,
}) => {
  // Removed pickedColor state
  const msColors = [
    '#ffff00', // Yellow category
    '#ff0000', // Red category
    '#800080', // Purple category
    '#ffa500', // Orange category
    '#008000', // Green category
    '#0000ff', // Blue category
  ]
  const msMapping = [
    'Yellow category',
    'Red category',
    'Purple category',
    'Orange category',
    'Green category',
    'Blue category',
  ]

  const googleColors = [
    '#a4bdfc', // 1 Lavender
    '#7ae7bf', // 2 Sage
    '#dbadff', // 3 Grape
    '#ff887c', // 4 Flamingo
    '#fbd75b', // 5 Banana
    '#ffb878', // 6 Tangerine
    '#46d6db', // 7 Peacock
    '#e1e1e1', // 8 Graphite
    '#5484ed', // 9 Blueberry
    '#51b749', // 10 Basil
    '#d50000', // 11 Tomato
  ]
  const calendarType = type

  // Helper to get the hex color based on the prop value
  const getHexFromProp = (propColor) => {
    if (propColor === 'default') return 'default'
    if (calendarType === 'ms' || calendarType === 'ews') {
      const index = msMapping.indexOf(propColor)
      return index !== -1 ? msColors[index] : 'default' // Fallback to default if name not found
    } else {
      // Google uses index + 1 as the ID string
      const index = parseInt(propColor) - 1
      return index >= 0 && index < googleColors.length ? googleColors[index] : 'default' // Fallback
    }
  }

  // Determine the currently selected hex color based *only* on the prop
  const currentHexColor = getHexFromProp(color)

  // Simplified color change handler
  function handleColorClick(hexColor) {
    if (calendarType === 'ms' || calendarType === 'ews') {
      const index = msColors.indexOf(hexColor)
      if (index !== -1) {
        onColorChangeCallback(msMapping[index])
      }
    } else {
      const index = googleColors.indexOf(hexColor)
      if (index !== -1) {
        onColorChangeCallback(`${index + 1}`) // Send back the Google ID string
      }
    }
  }

  // Handler for the "Default" checkbox
  function handleDefaultClick(isChecked) {
    if (isChecked) {
      onColorChangeCallback('default')
    }
    // If unchecked, do nothing (user must pick a specific color)
  }

  // Determine which colors to display
  const displayColors = calendarType === 'ms' || calendarType === 'ews' ? msColors : googleColors

  // --- Preview Rendering ---
  if (preview) {
    const previewHex = currentHexColor === 'default' ? '#eee' : currentHexColor // Use a neutral default for preview
    return <div className="w-2 h-full" style={{ background: previewHex }}></div>
  }

  // --- Full Picker Rendering ---
  return (
    <div>
      <div className="grid mb-1 grid-cols-4">
        {/* Color Swatches */}
        {displayColors.map((hex, i) => {
          const isSelected = hex === currentHexColor
          return (
            <div
              key={i}
              onClick={() => handleColorClick(hex)}
              className={`flex flex-col ${
                isSelected ? 'bg-neutral_1' : ''
              } place-items-center hover:border-neutral_2 mr-2 mb-2 border-2 border-sm border-neutral_1 p-2 cursor-pointer`} // Added cursor-pointer
            >
              <div
                className="rounded-full w-8 h-8 mb-1"
                style={{ background: hex }}
              ></div>
              <div>
                {isSelected ? (
                  <SelectOn></SelectOn>
                ) : (
                  <SelectOff></SelectOff>
                )}
              </div>
            </div>
          )
        })}
        {/* Default Option */}
        <div className="place-items-center hover:border-neutral_2 mr-2 mb-2 border-2 border-sm border-neutral_1 p-2">
          <div className="w-full">
            <CBCheckItem
              onChange={handleDefaultClick}
              checked={currentHexColor === 'default'}
              label="Calendar Default"
              border={false}
            ></CBCheckItem>
          </div>
        </div>
      </div>
    </div>
  )
}

export { CBColorPicker }
